import { computed, ref } from 'vue'

export interface ColumnConfig {
  key: string
  label: string
}

export const ALL_CONFIGURABLE_COLUMNS: ColumnConfig[] = [
  { key: 'number', label: 'Номер' },
  { key: 'name', label: 'Наименование' },
  { key: 'edition', label: 'Редакция документа' },
  { key: 'approved_at', label: 'Дата утверждения' },
  { key: 'doc_type', label: 'Вид' },
  { key: 'section', label: 'Разделы нормативов' },
  { key: 'status', label: 'Статус' },
  { key: 'author', label: 'Разработчик' },
  { key: 'created_by', label: 'Разместил документ' },
  { key: 'created_at', label: 'Дата загрузки' },
  { key: 'effective_at', label: 'Дата ввода в действие' },
  { key: 'valid_until', label: 'Дата истечения' },
]

const DEFAULT_VISIBLE_KEYS = ['number', 'name', 'approved_at', 'doc_type', 'section', 'status', 'author', 'created_by', 'created_at', 'effective_at', 'valid_until']
const STORAGE_KEY = 'documents-column-visibility'
const SHOW_FOLDERS_KEY = 'documents-show-folders'

function loadFromStorage(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      return JSON.parse(raw).map((key: string) => {
        if (key === 'creator') return 'created_by'
        if (key === 'type') return 'doc_type'

        return key
      })
    }
  } catch { /* ignore */ }
  return [...DEFAULT_VISIBLE_KEYS]
}

function loadShowFolders(): boolean {
  try {
    const raw = localStorage.getItem(SHOW_FOLDERS_KEY)
    if (raw !== null) { return raw === 'true' }
  } catch { /* ignore */ }
  return true
}

export function useColumnVisibility() {
  const visibleKeys = ref<string[]>(loadFromStorage())
  const showFolders = ref(loadShowFolders())

  const isVisible = (key: string) => visibleKeys.value.includes(key)

  const allSelected = computed(() =>
    ALL_CONFIGURABLE_COLUMNS.every(col => visibleKeys.value.includes(col.key)),
  )

  function save(keys: string[]) {
    visibleKeys.value = [...keys]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(keys))
  }

  function setShowFolders(value: boolean) {
    showFolders.value = value
    localStorage.setItem(SHOW_FOLDERS_KEY, String(value))
  }

  return {
    allColumns: ALL_CONFIGURABLE_COLUMNS,
    visibleKeys,
    allSelected,
    isVisible,
    save,
    showFolders,
    setShowFolders,
  }
}
